// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-jq6k{display:block}.YbCfd{position:relative;margin:0;cursor:pointer}.-jq6k .U5pHY{display:block;background-color:#f4f4f4;background-image:none}@media screen and (min-width:768px){.-jq6k .U5pHY{border-radius:8px}}.-jq6k .U5pHY._8bU\\+3 img{left:50%;width:auto;border-radius:0;transform:translateX(-50%)}.lXRAa{position:absolute;right:16px;bottom:16px;box-shadow:0 2px 10px rgba(0,0,0,.08)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "-jq6k",
	"picture": "YbCfd",
	"image": "U5pHY",
	"isVertical": "_8bU+3",
	"button": "lXRAa"
};
module.exports = ___CSS_LOADER_EXPORT___;
